<template>
  <section class="news">
    <div class="newsgrid">
      <div class="newrelease"></div>
      <div class="newreleasecover">
        <img src="../assets/pomcast19-m50_sc.jpg" alt="POMCAST19" />
      </div>
      <div class="presstext">
        <h3><i>POMCAST 19</i></h3>
        <h4>m50</h4>
        <p class="rec-info">
          <i
            >A lot has happened since our last pre-pandemic episode. While
            streaming DJ sets may have lost some momentum, we believe there's
            still a space for timeless, distinctive mixes from artists we
            respect — whether they're long-time players or emerging talents from
            our circle. So now feels like the right time to relaunch the
            Pomcast. <br />Kicking things off is our dear colleague and friend,
            Chicago’s own m50. For those familiar, m50 is synonymous with
            high-quality, deeply personal, and immersive electronic sets. His
            work through the weekly "etc radio" broadcasts, his productions as
            Area (his debut album dropped on François K’s Wave Music in 2012),
            and his vinyl-only label Kimochi all showcase a unique and nuanced
            musical voice. <br />To get a deeper sense of what makes m50 such a
            singular presence in the scene, check out
            <a href="https://ra.co/features/3497" target="_blank"
              >Resident Advisor’s Label of the Month feature from July 2019</a
            >.</i
          >
        </p>
        <div class="player2">
          <iframe
            width="100%"
            height="300"
            scrolling="no"
            frameborder="no"
            allow="autoplay"
            src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2134789275&color=%230a0909&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true"
          ></iframe>
          <div
            style="
              font-size: 10px;
              color: #cccccc;
              line-break: anywhere;
              word-break: normal;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-family: Interstate, Lucida Grande, Lucida Sans Unicode,
                Lucida Sans, Garuda, Verdana, Tahoma, sans-serif;
              font-weight: 100;
            "
          >
            <a
              href="https://soundcloud.com/pomelorecords"
              title="pomelo"
              target="_blank"
              style="color: #cccccc; text-decoration: none"
              >pomelo</a
            >
            ·
            <a
              href="https://soundcloud.com/pomelorecords/pomcast-19-m50"
              title="POMCAST 19 - m50"
              target="_blank"
              style="color: #cccccc; text-decoration: none"
              >POMCAST 19 - m50</a
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
/* Base styles */
body {
  font-family: "Roboto", sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f9f9f9;
  color: #333;
}

/* News section */
.news {
  padding: 25px 15px;
  margin: auto;
  max-width: 1200px;
  background-color: #ffffff;
}

/* Grid layout */
.newsgrid {
  display: grid;
  grid-template-rows: auto auto 1fr auto;
  grid-template-columns: 1fr 2fr 2fr 1fr;
  gap: 20px;
  align-items: center;
}

.newrelease {
  grid-column: 2 / 3;
  text-align: left;
  height: 50px;
}

.newreleasecover {
  grid-column: 2 / 3;
  align-self: start;
}

.newreleasecover img {
  max-width: 100%;
  height: auto;
  border-radius: 5px;
  transition: transform 0.3s ease-in-out;
}

.newreleasecover img:hover {
  transform: scale(1.05);
}

/* Press text */
.presstext {
  grid-column: 3 / 4;
  padding: 0 20px 10px 20px;
  text-align: justify;
  line-height: 1.6;
}

.presstext h3 {
  font-size: 1.1rem;
  color: #fff;
  background-color: #ccc;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 0;
}

.presstext h4 {
  margin-top: 20px;
  font-size: 2rem;
  margin-bottom: 10px;
  color: #333;
  /* text-align: center; */
}

.presstext p {
  font-size: 1rem;
  color: #666;
}
.rec-info a {
  text-decoration: none;
  color: #000;
}

/* Bandcamp player */
.player2 {
  grid-column: 2 / span 2;
  margin: auto;
  max-width: 500px;
}

/* Responsiveness */
@media screen and (max-width: 768px) {
  .newsgrid {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
  }

  .newrelease,
  .newreleasecover,
  .presstext,
  .player2 {
    grid-column: 1;
  }

  .presstext {
    padding: 10px;
  }
}

@media screen and (min-width: 1800px) {
  .newreleasecover img {
    width: 100%;
    max-width: 400px;
  }
  .presstext {
    font-size: 1.2rem;
    line-height: 1.8;
  }
}
</style>
